import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { HomePage } from './pages/HomePage';
import { ClientePage } from './pages/ClientePage';
import { ClienteCompromisosPage } from './pages/ClienteCompromisosPage';
import { FacilityPage } from './pages/FacilityPage';
import { PropuestaPage } from './pages/PropuestaPage';
import { ProtectedRoute } from './components/ProtectedRoute';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/cambiar-password" element={<ChangePasswordPage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/clientes/:clienteSlug" element={<ClientePage />} />
        <Route
          path="/clientes/:clienteSlug/compromisos"
          element={<ClienteCompromisosPage />}
        />
        <Route path="/clientes/:clienteSlug/:facilitySlug" element={<FacilityPage />} />
        <Route
          path="/clientes/:clienteSlug/:facilitySlug/:propuestaId"
          element={<PropuestaPage />}
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
